import { GET, POST } from 'utils/requests.utils'

const BASE_URL = '/cabinet/bonus_payments'

export const fetchList = (data) => GET(BASE_URL, data)

export const createItem = (data) => POST(BASE_URL, data)
